import axios from "axios";
import store from "../../store/index";
import jwt_decode from "jwt-decode";

export default {
  name: "DefaultSetupPopUp",
  data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/study/`,
      usersettingsBaseUrl: `${process.env.VUE_APP_Service_URL}/account-core/usersettings/`,
      baseurl: process.env.VUE_APP_Service_URL,
      baseAPI: `${process.env.VUE_APP_Service_URL}/account-core/user/`,
      Headers: "",
      idToken: "",
      userId: "",
      studyList: [],
      currentStudy: "",
      defaultdateFormat: "",
      defaultTimeFormat: "",
      defaultlanguage: "",
      defaultGraphType: "",
      langList: "",
      dateList: "",
      roleList: [],
      selectedRole: "",
      ProfileData: {
        emailIdPrimary: "",
      },
      value: {
        createdUserEmail: "vipinv@datamatica.uk",
        createdUserId: "auth0|61f28ddadaa5cc006ace40ba",
        createdAt: "2021-10-27T09:30:08.205Z",
        lastModifiedUserEmail: "vipinv@datamatica.uk",
        lastModifiedUserId: "auth0|61f28ddadaa5cc006ace40ba",
        lastModifiedAt: "2022-02-02T03:18:19.026Z",
        userID: "auth0|61f28ddadaa5cc006ace40ba",
        userEmail: "vipinv@datamatica.uk",
        studyID: "ee36418d-c121-4fd7-b332-ffccc6b690ff",
        createdDate: "2021-10-27T09:30:08.205Z",
      },
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.userId = this.jwtDecrypt(this.idToken).sub;
    this.value.userEmail = this.jwtDecrypt(this.idToken).name;
    this.value.createdUserEmail = this.jwtDecrypt(this.idToken).name;
    this.value.lastModifiedUserEmail = this.jwtDecrypt(this.idToken).name;
    this.Headers = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.getAndSetProfileData();
    await this.getUserSettings();
    await this.getAndSetData();
    await this.setCurrentStudy();
    await this.getlanguagelist();
    await this.getdateformatlist();
    await this.setRoleList();
    document.addEventListener("keydown", this.handleEsc);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleEsc);
  },
  methods: {
    handleEsc(e) {
      if (e.key === "Escape") {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    jwtDecrypt(token) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    },
    async getAndSetProfileData() {
      await axios
        .get(this.baseAPI + "getuserwithauthid?id=" + this.userId, this.Headers)
        .then((res) => {
          this.ProfileData = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setRoleList() {
      await axios
        .get(`${this.baseurl}/account-core/user/getuserroles`, {
          ...this.Headers,
          params: {
            userMail: jwt_decode(this.idToken).email,
          },
        })
        .then((res) => {
          this.roleList = res.data;
          if (
            this.roleList.length > 0 &&
            (this.selectedRole == null || this.selectedRole === "")
          ) {
            this.selectedRole = this.roleList[0].roleID;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateDefaultRole() {
      try {
        const res = await axios.put(
          this.usersettingsBaseUrl + "updatedefaultrole",
          {
            userId: jwt_decode(this.idToken).email,
            roleId: this.selectedRole,
          },
          this.Headers
        );
        console.log(res);
        await this.getUserSettings();
        await store.dispatch("setroles", [this.selectedRole]);
        await this.$router.push("/landingPage");
        window.location.reload();
      } catch (err) {
        console.log("Error updating default role", err);
      }
    },
    async languagechange(val) {
      store.dispatch("setLanguage", val);
      localStorage.setItem("lang", val);
      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, locale: val },
      });
      this.defaultlanguage = val;
    },
    async updateDefLanguage(defaultlanguage) {
      await axios
        .put(
          this.usersettingsBaseUrl + "updatelocallanguage",
          {
            userId: jwt_decode(this.idToken).email,
            localLanguage: this.defaultlanguage,
          },
          this.Headers
        )
        .then((res) => {
          console.log(res);
          this.languagechange(defaultlanguage);
          this.getUserSettings();
          alert(this.$t("navigations.default language updated successfully"));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getAndSetData() {
      const idtoken = store.getters.getIdToken;
      const usermail = jwt_decode(idtoken).email;
      await axios
        .get(`${this.baseapi}/management/study/getallstudy?user=${usermail}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.studyList = res.data;
          this.setCurrentStudy();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setCurrentStudy() {
      const idtoken = store.getters.getIdToken;
      const usermail = jwt_decode(idtoken).email;
      await axios
        .get(this.baseUrl + "getdefaultstudy?id=" + usermail, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.currentStudy = res.data.studyID;
          this.CreateDefStudy();
        })
        .catch((err) => {
          console.log(err.response.data.errors.DomainValidations[0]);
          if (
            err.response.data.errors.DomainValidations[0] ===
            "Study ID not exists."
          ) {
            this.CreateDefStudy();
          }
        });
    },
    async CreateDefStudy() {
      this.setVAlue();
      await axios
        .post(this.baseUrl + "createdefaultstudy", this.value, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async CreateDefLanguage() {
      await axios
        .post(
          this.usersettingsBaseUrl + "create",
          {
            userId: jwt_decode(this.idToken).email,
            localLanguage: "en",
            dateFormat: "d/MM/yyyy",
          },
          this.Headers
        )
        .then((res) => {
          console.log(res);
          this.defaultlanguage = "en";
          this.defaultdateFormat = "d/MM/yyyy";
          this.defaultTimeFormat = "";
          this.defaultGraphType = "";
          this.selectedRole = "";
          store.dispatch("setLanguage", "en");
          localStorage.setItem("lang", "en");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getlanguagelist() {
      await axios
        .get(this.usersettingsBaseUrl + "languagelist", this.Headers)
        .then((res) => {
          this.langList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getdateformatlist() {
      await axios
        .get(this.usersettingsBaseUrl + "dateformatlist", this.Headers)
        .then((res) => {
          this.dateList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getUserSettings() {
      await axios
        .get(
          this.usersettingsBaseUrl + "defaultsetup",
          {
            ...this.Headers,
            params: {
              userId: jwt_decode(this.idToken).email,
            },
          }
        )
        .then((res) => {
          if (res.data == "No data found") {
            return this.CreateDefLanguage();
          } else {
            this.defaultlanguage = res.data.localLanguage || "";
            this.defaultdateFormat = res.data.dateFormat || "";
            this.defaultTimeFormat = res.data.timeFormat || "";
            this.defaultGraphType = res.data.graphType || "";
            this.selectedRole = res.data.defaultRole || "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateDefDateFormat() {
      if (this.defaultdateFormat == "") {
        this.defaultdateFormat = "MM/DD/YYYY";
      }
      localStorage.setItem("dateformat", this.defaultdateFormat);
      await axios
        .put(
          this.usersettingsBaseUrl + "updatedateformat",
          {
            userId: this.ProfileData.emailIdPrimary,
            dateFormat: this.defaultdateFormat,
          },
          this.Headers
        )
        .then((res) => {
          console.log(res);
          alert(this.$t("navigations.default date format updated successfully"));
        })
        .catch((err) => {
          console.log(err);
        });
      this.getUserSettings();
    },
    async updateTimeFormat() {
      if (this.defaultTimeFormat == "") {
        this.defaultTimeFormat = "h:mm A";
      }
      localStorage.setItem("timeformat", this.defaultTimeFormat);
      await axios
        .put(
          this.usersettingsBaseUrl + "updatetimeformat",
          {
            userId: this.ProfileData.emailIdPrimary,
            timeFormat: this.defaultTimeFormat,
          },
          this.Headers
        )
        .then((res) => {
          console.log(res);
          alert(this.$t("navigations.default time format updated successfully"));
        })
        .catch((err) => {
          console.log(err);
        });
      this.getUserSettings();
    },
    async updateGraphType() {
      localStorage.setItem("graphType", this.defaultGraphType);
      await axios
        .put(
          `${this.usersettingsBaseUrl}updategraphtype`,
          {
            userId: this.ProfileData.emailIdPrimary,
            graphType: this.defaultGraphType,
          },
          this.Headers
        )
        .then((res) => {
          console.log(res);
          alert(this.$t("navigations.default graph type updated successfully"));
        })
        .catch((err) => {
          console.log(err);
        });
      this.getUserSettings();
    },
    async UpdateClicked() {
      this.UpdateDefStudy();
    },
    async UpdateDefStudy() {
      this.setVAlue();
      await axios
        .post(this.baseUrl + "updatedefaultstudy", this.value, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          alert(this.$t("navigations.default study updated successfully"));
          store.dispatch("setStudyID", this.value.studyID);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setVAlue() {
      this.value.userID = this.userId;
      this.value.createdUserId = this.userId;
      this.value.lastModifiedUserId = this.userId;
      if (this.currentStudy == "") {
        this.value.studyID = null;
      } else {
        this.value.studyID = this.currentStudy;
      }
    },
    ClearValue() {
      this.value.userID = "";
      this.value.userEmail = "";
      this.value.studyID = "";
    },
  },
};
